import React from 'react';
import { createStyles } from './AssignmentSidebar.styles';
import {
  Box,
  Button,
  Divider,
  Icons,
  Typography,
  useTheme,
} from '@ublend-npm/aulaui-core';
import NavigationBackHeader from '@app/components/presentational/common/NavigationBackHeader/NavigationBackHeader';
import { ASSIGNMENTS } from '@app/constants/texts';
import { ResponsiveAssignment } from '@core/assignments/types';
import AssignmentList from '../List/AssignmentList';

type Props = {
  assignments: ResponsiveAssignment[];
  backRoute: string | null;
  spaceId: string;
  onMaterialClick?: (materialId: string) => void;
};

const AssignmentSidebar = ({
  assignments,
  backRoute,
  spaceId,
  onMaterialClick,
}: Props) => {
  const theme = useTheme();
  const styles = createStyles(theme);

  return (
    <Box sx={styles.sidebarWrapper}>
      <Box sx={styles.buttonWrapper}>
        <NavigationBackHeader route={backRoute} />
      </Box>
      <Box sx={styles.sidebarContent}>
        <Box sx={styles.headerWrapper}>
          <Box sx={styles.headerIcon} aria-hidden>
            <Icons.AssessmentOutlined fontSize="medium" />
          </Box>
          <Box>
            <Typography component="h2" variant="h6" sx={styles.title}>
              {ASSIGNMENTS}
            </Typography>
          </Box>
        </Box>
        <Box>
          <Button type="button" kind="primary" sx={styles.createButton}>
            <Icons.Add />
            New assignment
          </Button>
        </Box>
        <Divider sx={{ my: '16px' }} />
        <Box sx={styles.listWrapper}>
          <AssignmentList
            assignments={assignments}
            spaceId={spaceId}
            onMaterialClick={onMaterialClick}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default AssignmentSidebar;
